/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: CompanyHasConnectedCallout.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/22 @ 1631
 * ---
 * Description:
 */

import { Callout, Intent } from '@blueprintjs/core';

export const CompanyHasConnectedCallout = () => {
  return (
    <Callout title="La tua azienda utilizza MyLabel" intent={ Intent.PRIMARY }
             className="mb-2">
      <div className="my-2"> Abbiamo rilevato che la tua azienda utilizza
        MyLabel. Inserisci le
        credenziali per continuare su questo computer
      </div>
    </Callout>
  );
};